/**
 * Admin Configuration
 */

// Super Admin Email from Environment Variable
// This ensures the email is not hardcoded and exposed in the repository
export const SUPER_ADMIN_EMAIL = process.env.REACT_APP_SUPER_ADMIN_EMAIL || 'admin@akmobooks.com';

export const isAdminEmail = (email: string | null | undefined): boolean => {
    if (!email || !SUPER_ADMIN_EMAIL) return false;
    return email.toLowerCase() === SUPER_ADMIN_EMAIL.toLowerCase();
};
